import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rating" }

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Rating',
  props: {
  modelValue: {
    type: Number,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



const rating = ref<number>(props.modelValue);

watch(
  props,
  () => {
    rating.value = props.modelValue;
  },
  { deep: true },
);



const starState = (r: number) => {
  return r <= rating.value ? 'full' : 'empty';
};

const updateRating = (value: number) => {
  rating.value = value;
  emit('update:modelValue', rating.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: _normalizeClass('icon icon-star-' + starState(1)),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (updateRating(1)))
    }, null, 2),
    _createElementVNode("li", {
      class: _normalizeClass('icon icon-star-' + starState(2)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (updateRating(2)))
    }, null, 2),
    _createElementVNode("li", {
      class: _normalizeClass('icon icon-star-' + starState(3)),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (updateRating(3)))
    }, null, 2),
    _createElementVNode("li", {
      class: _normalizeClass('icon icon-star-' + starState(4)),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (updateRating(4)))
    }, null, 2),
    _createElementVNode("li", {
      class: _normalizeClass('icon icon-star-' + starState(5)),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (updateRating(5)))
    }, null, 2)
  ]))
}
}

})